import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Header from "../../components/Header/Header";
import headerImg from "../../assets/images/backgrounds/skärm1.jpg";
import "./Career.css";
import Card from "../../components/Cards/Card/Card";
import uiux from "../../assets/images/career/skärm.jpg";
import frontend from "../../assets/images/services/skärm.jpg";
import backend from "../../assets/images/services/skärm.jpg";

class Career extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mapOverlay: "mapOverlay"
    };
  }

  isMobile() {
    return window.innerWidth < 768;
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Corviva | Karriär</title>
          <meta name="description" content="" />
          <meta name="keywords" content="webbportal hälsa företagshälsovård arbetsmiljö hälsoundersökning" />
        </Helmet>
        <Header
          big_header="Karriär"
          bgImage={headerImg}
          strength={200}
          page="career"
          offset={this.isMobile() ? 0 : -30}
        />
        <div id="career" className="career">
          <div className="row newSection mx-auto text-center">
            <h3 className="cardGroupTitle col-12">
              Find your next position with us
            </h3>
            <div className="card-group col-12">
              <div className="col-lg-4 col-12">
                <Card
                  src={uiux}
                  title="UI / UX"
                  text="This card has supporting text below as a natural lead-in to additional content."
                  textColor="black"
                  onClick={() => this.props.click_function("career", "uiux")}
                  to="/career/uiux"
                  footer
                  footerColor="white"
                  button="btn-whiteOnWhite"
                  className="card"
                />
              </div>
              <div className="col-lg-4 col-12">
                <Card
                  src={frontend}
                  title="frontend"
                  text="This card has supporting text below as a natural lead-in to additional content."
                  textColor="black"
                  onClick={() => this.props.click_function("career", "frontend")}
                  to="/career/frontend"
                  footer
                  footerColor="white"
                  button="btn-whiteOnWhite"
                  className="card"
                />
              </div>
              <div className="col-lg-4 col-12">
                <Card
                  src={backend}
                  title="backend"
                  text="This card has supporting text below as a natural lead-in to additional content."
                  textColor="black"
                  onClick={() => this.props.click_function("career", "backend")}
                  to="/career/backend"
                  footer
                  footerColor="white"
                  button="btn-whiteOnWhite"
                  className="card"
                />
              </div>
            </div>
          </div>
          <div className="row newSection text-center oddSection">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 careerIntro">
              <h3>What are you waiting for?</h3>
              <p className="section-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                tristique nisl non eleifend posuere. Nam mollis leo at neque
                sagittis elementum. Nullam pulvinar ut ante ut auctor.
                Suspendisse convallis, tellus vitae egestas mattis, neque magna
                malesuada lacus, vel dignissim felis elit eget odio. Vestibulum
                imperdiet, mauris maximus eleifend varius, justo lorem pretium
                purus, vitae tristique eros velit non eros. Nam rutrum tempor
                ligula sed convallis.
              </p>
            </div>
          </div>
          <div className="row text-center">
            {/* <h3 className=" mapHeading col-12">Come in and chat with us</h3> */}
            <div className="col-12 mapContainer">
              <div
                className={this.state.mapOverlay}
                onClick={() => {
                  this.state.mapOverlay === "mapOverlay"
                    ? this.setState({ mapOverlay: "mapOverlay noPointer" })
                    : this.setState({ mapOverlay: "mapOverlay" });
                }}
                role="presentation"
              />
              <iframe
                className="map"
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2003.1876305379137!2d17.63458855163352!3d59.86263057510083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465fcbf294000001%3A0xdfb1d59ac575c754!2sApp+Shack+AB!5e0!3m2!1sen!2sse!4v1500382901647"
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Career.propTypes = {
  click_function: PropTypes.func
};

Career.defaultProps = {
  click_function: () => {}
};

export default Career;



// WEBPACK FOOTER //
// ./src/routes/Career/Career.jsx